import { parseJson } from "src/shared/utils";

export interface Filter {
  field: string;
  value: string[];
}
export interface ISingleManageMetrics {
  id: number;
  label: string;
  filters: Array<{ [key: string]: string | string[] }> | string;
  performanceChartIds: number[];
  currentChartId: number;
  trendChartId: number;
  pastChartId: number;
  offset: number;
}

export interface IAllManageMetrics {
  allmetrics: ISingleManageMetrics[];
  formatedFilterData: string[];
  pageNo: number;
  pageSize: number;
  hasMore: boolean;
  //prepareAPICallData: () =>
}

export default class ManageMetricsModel implements IAllManageMetrics {
  public allmetrics: ISingleManageMetrics[];
  public formatedFilterData: string[];
  public pageNo: number;
  public pageSize: number;
  public hasMore: boolean;
  public static createManageMetric(data: any) {
    return new ManageMetricsModel(data);
  }
  public constructor(obj: any) {
    this.allmetrics = [];
    if (obj.data && obj.data.length > 0) {
      this.allmetrics = obj.data.map((curr) => ({
        id: curr.id,
        label: curr.label,
        filters: parseJson(curr.filters),
        performanceChartIds: curr.performanceChartIds,
        trendChartId: curr.trendChartId,
        currentChartId: curr.currentChartId,
        pastChartId: curr.pastChartId,
        offset: curr.offset,
        isHidden: curr.isHidden,
      }));
    }
    //if (this.allmetrics.length > 0) this.allmetrics = this.sortMetrics(this.allmetrics);
    this.formatedFilterData = this.allmetrics.map(this.formatFilterData);
    this.pageNo = obj.pageNo ? obj.pageNo : 0;
    this.pageSize = obj.pageSize ? obj.pageSize : 0;
    this.hasMore = obj.hasMore ? obj.hasMore : 0;
  }
  public sortMetrics(formatData: ISingleManageMetrics[]): ISingleManageMetrics[] {
    const newformattedArr: ISingleManageMetrics[] = formatData.sort((a, b) => {
      if (a.offset > b.offset) return 1;
      else return -1;
    });
    return newformattedArr;
  }

  public formatFilterData = (data: any): string => {
    let lineData: ISingleManageMetrics[] = [];
    if (data.filters && typeof data.filters === "string") {
      data.filters = parseJson(data.filters);
    }
    data.filters &&
      data.filters.forEach((curr) => {
        if (typeof curr.value === "string") {
          lineData.push(curr.value);
        } else if (typeof curr.value === "object") {
          if (curr.value.length > 0) lineData.push(curr.value.join(" | "));
        }
      });
    return lineData.join(" | ");
  };
  public static prepareAPICallData(data: ISingleManageMetrics[]): ISingleManageMetrics[] {
    let payloadData = data;
    payloadData.forEach((curr) => {
      curr.filters = JSON.stringify(curr.filters);
    });
    return payloadData;
  }
}
